<template>
  <ul class="com-unit">
    <li class="txt"><i class="el-icon-star-on star" /> 第1行的描述</li>
    <li class="txt"><i class="el-icon-bell" /> 第2行的描述</li>
  </ul>
</template>

<script>
export default {
  components: {},

  props: {},
  data() {
    return {}
  },

  computed: {},

  created() {},

  mounted() {},

  methods: {}
}
</script>

<style lang="scss">
@import "@/static/css/mixins.scss";

.com-unit {
  // white-space: nowrap;
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 16px;
  .star {
    color: #67c23a;
  }

  .txt {
    color: #e6a23c;
  }
}
</style>
